// Shared sub-categories config for the "Total Defects Breakdown" widgets in
// FinalReportDashboard and ProductList. Defines which top-level tab and
// sub-tab each defect name belongs to. Names not present in the config are
// dropped — there is intentionally no catch-all.

export const DEFAULT_SUB_CATEGORIES_CONFIG = {
    pavement: {
        pavement_condition: {
            label: 'Pavement Condition',
            names: ['Potholes', 'Cracking', 'Rutting', 'Stripping/Delamination',
                'Pavement Damage (Severe)', 'Unsealed Road', 'Settlement',
                'Water Stagnation', 'Pavement Joint', 'Patching'],
        },
        shoulder_condition: {
            label: 'Shoulder Condition',
            names: ['Shoulder - Edge Drop', 'Shoulder - Unevenness', 'Shoulder - Rain Cuts',
                'Unevenness / Edge Drop of shoulder', 'Rain Cuts'],
        },
    },
    assets: {
        signages: {
            label: 'Signages',
            names: ['Damaged Sign Boards / Sign Structures', 'Signage - Poor Visibility (Day)', 'Signage - Poor Visibility (Night)',
                'Visibility of Signages (Day/Night)'],
        },
        highway_lighting: {
            label: 'Highway Lighting',
            names: ['Damaged Highway Lights', 'Non-Functional Highway Lights',
                'Highway Lights Damaged', 'Non-functional lights'],
        },
        change_detection: {
            label: 'Change Detection',
            names: ['Missing Assets (Street Lights)'],
        },
        crash_barriers: {
            label: 'Crash Barriers & Guard Rails',
            names: ['Damaged Crash Barriers', 'Damaged (MBCB) Metal Beam Crash Barrier', 'Damaged (PGR) Pedestrian Guard Rail',
                'Damaged Crash Barriers / Guardrails (CC/MBCB)'],
        },
        kerb_median: {
            label: 'Kerb & Median',
            names: ['Damaged Kerb',
                'Damaged Kerb / Faded Kerb Painting'],
        },
        drainage: {
            label: 'Drainage',
            names: ['Damaged Drain Cover Slabs', 'Missing Drain Cover Slabs',
                'Damaged / Missing Drain Cover Slabs'],
        },
        footpath: {
            label: 'Footpath',
            names: ['Damaged Footpath Tiles / Paver Blocks',
                'Damaged Footpath (Tiles/Pavers)'],
        },
        safety_devices: {
            label: 'Safety Devices',
            names: ['Damaged Blinkers', 'Damaged Attenuators', 'Damaged Delineators', 'Damaged Anti-Glare',
                'Damaged Blinkers / Attenuators / Delineators/ Anti-Glare'],
        },
        road_studs_markers: {
            label: 'Road Studs & Markers',
            names: ['Damaged Hazard Markers', 'Damaged Road Studs', 'Road Studs - Poor Visibility (Day)', 'Road Studs - Poor Visibility (Night)',
                'Missing/damaged Road Studs / Rumble Strips / Hazard Markers',
                'Visibility of Studs & Markers (Day/Night)'],
        },
        bus_bay: {
            label: 'Bus Bay & Truck Lay-By',
            names: ['Bus Bay - Damaged Shelters', 'Bus Bay - Faded Markings', 'Bus Bay - Damaged Signages',
                'Truck Lay By - Damaged Shelters', 'Truck Lay By - Faded Markings', 'Truck Lay By - Damaged Signages',
                'Damaged Bus Shelters', 'Faded Bus Bay / Truck Lay-By Markings'],
        },
        plantation: {
            label: 'Plantation / Landscaping',
            names: ['Missing Plants / Irregular Gaps (Median)', 'Deteriorated or Damaged Plants (Median)', 'Reduced Visibility due to Overgrowth',
                'Damaged / Deteriorated Plants', 'Missing Plants / Irregular Gaps',
                'Reduced Sight Distance (due to Overgrowth)'],
        },
        unauthorized: {
            label: 'Unauthorized Activity',
            names: ['Unauthorized Hoardings',
                'Unauthorized Signboards / Hoardings', 'Holding / Advertisement Boards'],
        },
    },
    roadSafety: {
        rumble_strips: {
            label: 'Rumble Strips & Markers',
            names: ['Damaged Rumble Strips', 'Damaged Hazard Markers'],
        },
        pavement_markings: {
            label: 'Pavement Markings',
            names: ['Faded Pavement Marking', 'Pavement Marking - Poor Visibility (Day)', 'Pavement Marking - Poor Visibility (Night)',
                'Pavement Marking (Faded)', 'Pavement Marking Visibility (Day/Night)'],
        },
        work_zone: {
            label: 'Work Zone Safety',
            names: ['Work Zone - Inadequate Signboard Visibility', 'Work Zone - Inadequate Barricading', 'Work Zone - Poor Diversion Arrangement / Condition',
                'Work Zone Safety (Signboard Visibility, Barricading)', 'Inappropriate Diversions'],
        },
        crash_barriers: {
            label: 'Crash Barriers & Guard Rails',
            names: ['Damaged Crash Barriers', 'Faded Painting Concrete Crash (CC) Barrier', 'Damaged (MBCB) Metal Beam Crash Barrier',
                'Missing Assets (Guard Rails)', 'Damaged (PGR) Pedestrian Guard Rail', 'Barriers - Faded Painting Guard Rails',
                'Faded Painting on Barriers'],
        },
        road_studs: {
            label: 'Road Studs',
            names: ['Damaged Road Studs', 'Road Studs - Poor Visibility (Day)', 'Road Studs - Poor Visibility (Night)'],
        },
        kerb_median: {
            label: 'Kerb & Median',
            names: ['Damaged Kerb', 'Faded Kerb Painting', 'Median Separator Damaged', 'Median Separator Paint Faded'],
        },
        drainage: {
            label: 'Drainage',
            names: ['Manhole Cover'],
        },
        unauthorized: {
            label: 'Unauthorized Activity',
            names: ['Unauthorized Median Openings', 'General Encroachments', 'Illegal Parking', 'Unauthorized Signboards',
                'Encroachment', 'Encroachments/ illegal Parking'],
        },
        plantation: {
            label: 'Plantation / Landscaping',
            names: ['Excessive Plantation Growth', 'Reduced Visibility Due To Plantation Growth'],
        },
        cleanliness: {
            label: 'Cleanliness',
            names: ['Cleanliness - Litter', 'Cleanliness - Debris',
                'Cleanliness (Poor)', 'Vegetation Growth on Shoulders'],
        },
    },
};

// Mirrors BHILWARA_SUB_CATEGORIES_CONFIG in MultiMap.js so the dashboard,
// GIS map, and chainage drill-down all categorize Bhilwara labels the same
// way. Keep them in sync if labels shift.
export const BHILWARA_SUB_CATEGORIES_CONFIG = {
    pavement: {
        pavement_condition: {
            label: 'Pavement Condition',
            names: [
                'Potholes', 'Cracking', 'Rutting', 'Patching', 'Pavement Damage',
                'Unsealed Road', 'Corner Break (Concrete)', 'Faulting at Joints',
                'Blow-up (Buckling)', 'Water Stagnation',
            ],
        },
        shoulder_condition: {
            label: 'Shoulder Condition',
            names: ['Shoulder - Edge Drop', 'Shoulder - Unevenness', 'Shoulder - Vegetation Growth',
                'Unevenness / Edge Drop of shoulder', 'Rain Cuts'],
        },
    },
    assets: {
        kerb_median:    { label: 'Kerb & Median Condition',     names: ['Damaged Kerb', 'Faded Kerb Painting', 'Median Separator Damaged', 'Median Separator Paint Faded',
            'Damaged Kerb / Faded Kerb Painting'] },
        plantation:     { label: 'Plantation / Landscaping',    names: ['Reduced Visibility Due to Plantation Growth', 'Missing Plants / Irregular Gaps (Median)', 'Deteriorated or Damaged Plants (Median)', 'Excessive Plantation Growth',
            'Damaged / Deteriorated Plants', 'Missing Plants / Irregular Gaps', 'Reduced Sight Distance (due to Overgrowth)'] },
        drainage:       { label: 'Drainage',                    names: ['Damaged Drain Cover Slabs', 'Missing Drain Cover Slabs', 'Manhole Cover', 'Water Stagnation',
            'Damaged / Missing Drain Cover Slabs'] },
        footpath:       { label: 'Footpath',                    names: ['Damaged Footpath Tiles / Paver Blocks',
            'Damaged Footpath (Tiles/Pavers)'] },
        crash_barriers: { label: 'Crash Barriers & Guard Rails', names: ['Damaged Crash Barriers', 'Damaged (MBCB) Metal Beam Crash Barrier', 'Damaged (PGR) Pedestrian Guard Rail', 'Faded Painting Concrete Crash (CC) Barrier', 'Barriers - Faded Painting Guard Rails',
            'Damaged Crash Barriers / Guardrails (CC/MBCB)', 'Faded Painting on Barriers'] },
        signages:       { label: 'Signages',                    names: ['Damaged Sign Boards / Sign Structures', 'Signage - Poor Visibility (Day)', 'Signage - Poor Visibility (Night)',
            'Visibility of Signages (Day/Night)'] },
        safety_devices: { label: 'Safety Devices',              names: ['Damaged Blinkers', 'Damaged Delineators',
            'Damaged Blinkers / Attenuators / Delineators/ Anti-Glare'] },
        road_studs:     { label: 'Road Studs & Markers',        names: ['Damaged Road Studs', 'Damaged Rumble Strips', 'Damaged Hazard Markers',
            'Missing/damaged Road Studs / Rumble Strips / Hazard Markers', 'Visibility of Studs & Markers (Day/Night)'] },
        encroachment:   { label: 'Encroachment',                names: ['Unauthorized Median Openings', 'Unauthorized Hoardings', 'Illegal Parking', 'General Encroachments',
            'Unauthorized Signboards / Hoardings', 'Holding / Advertisement Boards', 'Encroachment', 'Encroachments/ illegal Parking'] },
        bus_bay:        { label: 'Bus Bay & Truck Lay-By',      names: ['Bus Bay - Damaged Shelters', 'Bus Bay - Faded Markings', 'Bus Bay - Damaged Signages',
            'Damaged Bus Shelters', 'Faded Bus Bay / Truck Lay-By Markings'] },
        cleanliness:    { label: 'Cleanliness',                 names: ['Cleanliness (Litter)', 'Cleanliness (Debris)',
            'Cleanliness (Poor)', 'Vegetation Growth on Shoulders'] },
    },
    roadSafety: {
        pavement_markings: { label: 'Pavement Marking',  names: ['Faded Pavement Markings',
            'Pavement Marking (Faded)', 'Pavement Marking Visibility (Day/Night)'] },
        highway_lighting:  { label: 'Highway Lighting',  names: ['Missing Road Lights', 'Damaged Road Lights', 'Non-Functional Road Lights',
            'Highway Lights Damaged', 'Non-functional lights'] },
        work_zone:         { label: 'Work Zone Safety',  names: ['Work Zone - Inadequate Signboard Visibility', 'Work Zone - Inadequate Barricading', 'Work Zone - Poor Diversion Arrangement / Condition',
            'Work Zone Safety (Signboard Visibility, Barricading)', 'Inappropriate Diversions'] },
    },
};

// ── Asset Inventory (4th top-level group) ─────────────────────────────────────
// Physical road-asset detections (NOT defects). 83 model classes grouped into 13
// sub-categories. Single source of truth — imported & spread into the inline
// configs in MultiMap.js, FinalReport.js, and (via the two configs above) used by
// ProductList.js. `names` use the lowercased, underscored backend form so they
// match `normalizeLabel(label).toLowerCase()` everywhere.
// `names` are in the SPACE-separated lowercase form (e.g. 'street light'), which is how
// the GIS filter formats labels for display (info.label.split('_').join(' ')). The
// normalizer in ASSET_INVENTORY_NAME_SET / isAssetInventoryName collapses spaces and
// underscores, so raw backend forms like 'Street_Light' still match.
export const ASSET_INVENTORY_CONFIG = {
    assetInventory: {
        carriageway_roadway: {
            label: 'Carriageway & Roadway',
            names: ['carriageway', 'shoulder', 'median', 'accessway', 'parking bay',
                'road batter', 'interlock area', 'gravel area', 'sand area'],
        },
        kerbs_islands: {
            label: 'Kerbs & Islands',
            names: ['kerb', 'kerbstone', 'central roundabout island', 'junction island',
                'separator island'],
        },
        pedestrian_facilities: {
            label: 'Pedestrian Facilities',
            names: ['footpath', 'jogger track', 'bike rack'],
        },
        structures_crossings: {
            label: 'Structures & Crossings',
            names: ['culvert', 'flyover', 'footbridge', 'overpass ov',
                'overpass op only pedestrian', 'underpass', 'pedestrian underpass',
                'tunnel', 'viaduct', 'cable bridge', 'retaining wall'],
        },
        road_safety_devices: {
            label: 'Road Safety Devices',
            names: ['guardrail', 'crash cushion', 'vehicle restraint system',
                'rumble strip', 'speed humps', 'road studs', 'traffic bollard',
                'animal grid'],
        },
        fencing: {
            label: 'Fencing',
            names: ['fence', 'animal fence', 'decorative fence'],
        },
        signage: {
            label: 'Signage',
            names: ['traffic sign', 'street sign', 'gantry directional sign',
                'pole directional sign', 'directional structure', 'hoarding'],
        },
        road_markings: {
            label: 'Road Markings',
            names: ['road marking line', 'road marking point', 'road marking polygon'],
        },
        traffic_signals: {
            label: 'Traffic Signals',
            names: ['traffic signal', 'traffic signal head', 'traffic signal junction',
                'traffic signal feeder pillar'],
        },
        street_lighting: {
            label: 'Street Lighting',
            names: ['street light', 'street light pole', 'street light feeder pillar',
                'landscape light', 'recessed light', 'underpass luminaire'],
        },
        its_monitoring: {
            label: 'ITS & Monitoring',
            names: ['air quality monitoring system aqms', 'closed circuit television cctv',
                'dynamic message sign dms', 'small dynamic messaging sign',
                'lane control signs lcs', 'emergency phone', 'ovds speaker',
                'over height vehicle detection system ovds',
                'road weather information system rwis', 'its enclosure',
                'its feeder pillar', 'its structure'],
        },
        landscaping: {
            label: 'Landscaping',
            names: ['tree', 'treeguard', 'hedge', 'garden', 'flower bed', 'planter pot',
                'natural grass', 'artificial grass'],
        },
        street_furniture: {
            label: 'Street Furniture & Amenities',
            names: ['bench', 'bin', 'monument', 'fitness equipment', 'fire extinguisher'],
        },
    },
};

// Display label for the Asset Inventory top-level tab.
export const ASSET_INVENTORY_TAB_LABEL = 'Asset Inventory';

// Neutral color for asset-inventory markers/tiles (assets have no defect severity).
export const ASSET_INVENTORY_COLOR = '#6B7280'; // slate gray

// Normalize a label the same way MultiMap does, then lowercase, for asset matching.
const _normAssetName = (label) =>
    String(label || '').replace(/–|−|—/g, '-').replace(/[\s_]+/g, '_').toLowerCase();

// Fast lookup set of all 83 asset-inventory names (already normalized/lowercased).
export const ASSET_INVENTORY_NAME_SET = new Set(
    Object.values(ASSET_INVENTORY_CONFIG.assetInventory)
        .flatMap(sub => sub.names.map(n => _normAssetName(n)))
);

// normalized name → friendly display label (e.g. 'street_light' → 'Street Light').
export const ASSET_INVENTORY_DISPLAY = (() => {
    const map = {};
    ASSET_INVENTORY_NAME_SET.forEach(n => {
        map[n] = n
            .replace(/_/g, ' ')
            .replace(/\b\w/g, c => c.toUpperCase());
    });
    return map;
})();

// True when a raw label belongs to the asset-inventory taxonomy.
export function isAssetInventoryName(name) {
    return ASSET_INVENTORY_NAME_SET.has(_normAssetName(name));
}

// normalized asset name → { subKey, subLabel } for grouping into the 13 sub-categories.
const _ASSET_NAME_TO_SUB = (() => {
    const map = {};
    Object.entries(ASSET_INVENTORY_CONFIG.assetInventory).forEach(([subKey, sub]) => {
        sub.names.forEach(n => { map[_normAssetName(n)] = { subKey, subLabel: sub.label }; });
    });
    return map;
})();

// Return { subKey, subLabel } for an asset label, or null if it isn't an asset.
export function getAssetSubCategory(name) {
    return _ASSET_NAME_TO_SUB[_normAssetName(name)] || null;
}

// Merge the Asset Inventory group into both defect configs so every consumer that
// reads getSubCategoriesConfig() (ProductList, and the iterators in FinalReport) gets
// the 4th top-level group. Done after ASSET_INVENTORY_CONFIG is defined above.
DEFAULT_SUB_CATEGORIES_CONFIG.assetInventory = ASSET_INVENTORY_CONFIG.assetInventory;
BHILWARA_SUB_CATEGORIES_CONFIG.assetInventory = ASSET_INVENTORY_CONFIG.assetInventory;

export function getSubCategoriesConfig(isBhilwaraUser) {
    return isBhilwaraUser ? BHILWARA_SUB_CATEGORIES_CONFIG : DEFAULT_SUB_CATEGORIES_CONFIG;
}

// name (lowercased) → top-level tab key ('pavement' | 'assets' | 'roadSafety')
// Used to categorize a defect into its tab without keyword guessing. Names
// not present in the config are not in this map and should be dropped.
export function buildNameToTopCategory(subCategoriesConfig) {
    const map = {};
    Object.entries(subCategoriesConfig).forEach(([topKey, subs]) => {
        Object.values(subs).forEach(sub => {
            sub.names.forEach(n => { map[n.toLowerCase()] = topKey; });
        });
    });
    return map;
}
